import styled from 'styled-components'

import { Colors, Sizes, FontLight, FontRegular, Breakpoints } from './../../utils/variables'

export const StyledContainer = styled.div`
    position: relative;

    width: 100%;
    max-width: ${Sizes.maxContainerWidth};

    margin: 0 auto;
    padding: 80px 30px 30px;

    h1 {
        font-size: 25px;
        line-height: 1em;
    }

    @media screen and (min-width: ${Breakpoints.wide}) {
        padding: 180px 70px 80px 70px;

        h1 {
            font-size: 80px;
        }
    }

    @media screen and (min-width: ${Sizes.maxContainerWidth}) {
        padding: 180px 0 80px 0;
    }
`

export const Title = styled.h1`
    width: 100%;

    ${FontLight}
    letter-spacing: -0.5px;

    color: ${props => (props.theme === 'light') ? `${Colors.white}` : `${Colors.blue}`};

    text-align: ${props => (props.align === 'center') ? `center` : `left`};
    text-transform: uppercase;

    @media screen and (min-width: ${Breakpoints.wide}) {
        max-width: ${Sizes.maxContentWidth};

        margin: ${props => (props.align === 'center') ? `0 auto` : `0`};
    }
`

export const TitleSmall = styled.h2`
    width: 100%;

    ${FontLight}
    font-size: 18px;
    line-height: 25px;

    color: ${props => (props.theme === 'light') ? `${Colors.white}` : `${Colors.blue}`};

    text-align: ${props => (props.align === 'center') ? `center` : `left`};
    text-transform: uppercase;

    @media screen and (min-width: ${Breakpoints.wide}) {
        max-width: ${Sizes.maxContentWidth};

        margin: ${props => (props.align === 'center') ? `0 auto` : `0`};
        
        ${FontRegular}
        font-size: 30px;
        line-height: 40px;
    }
`